import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Grid from 'material-ui/Grid';
import Card, { CardMedia, CardContent, CardActions } from 'material-ui/Card';
import Button from 'material-ui/Button';

const Home = (props) => (
	<div>
		<Typography variant="display1">Wellcome to the Generator-App</Typography>
		<Grid container className={props.classes.container}>
			{props.items.map((item, key) => (
				<Grid key={key} item xs={12} sm={6} md={4} lg={3}>
					<Card>
						<CardMedia className={props.classes.media} image={item.image} />
						<CardContent>
							<Typography variant="headline" component="h2">{item.name}</Typography>
							<Typography variant="subheading" color="textSecondary">Generator</Typography>
							<Typography component="p">{item.description}</Typography>
						</CardContent>
						<CardActions>
							<Button size="small" component={Link} to={item.link.path}>{item.link.label}</Button>
						</CardActions>
					</Card>
				</Grid>
			))}
		</Grid>
	</div>
);

Home.propTypes = {
	classes: PropTypes.object.isRequired,
	items: PropTypes.array.isRequired
};

const styles = theme => ({
	container: {
		marginTop: theme.spacing.unit * 3
	},
	media: {
		height: 200
	}
});

export default withStyles(styles)(Home);



// WEBPACK FOOTER //
// ./src/components/Home/index.js